import { trackPublicEvent } from "@/features/analytics/api";
import type {
  EventPrefix,
  GoogleTagManagerEventDetails,
} from "@/features/analytics/models";
import {
  CUSTOMER_IO_EVENT,
  EVENT_PREFIX,
  GOOGLE_TAG_MANAGER_EVENT,
} from "@/features/analytics/models";
import { triggerGoogleTagManagerTracking } from "@/features/analytics/triggers/google-tag-manager";
import { categoriesToGoogleTagManagerProducts } from "@/features/analytics/utils";
import type { OnboardingUser } from "@/features/onboarding/models";
import type { CategoryWithSelectedProduct } from "@/features/products/models";
import { calculateTotal } from "@/features/products/utils";
import type { PaymentMethodType } from "@/shared/domains/payments/models";
import { CURRENCY } from "@/shared/models";

interface TrackCompletePurchaseClickedParams {
  selectedCategories: CategoryWithSelectedProduct[];
  user?: OnboardingUser;
  paymentMethod?: PaymentMethodType;
  eventPrefix?: EventPrefix;
}

export const trackCompletePurchaseClicked = ({
  user,
  selectedCategories,
  paymentMethod,
  eventPrefix = EVENT_PREFIX.NONE,
}: TrackCompletePurchaseClickedParams) => {
  const value = calculateTotal(selectedCategories);
  const items = categoriesToGoogleTagManagerProducts(selectedCategories);

  triggerGoogleTagManagerTracking<GoogleTagManagerEventDetails>({
    event: `${eventPrefix}${GOOGLE_TAG_MANAGER_EVENT.COMPLETE_PURCHASE_CLICKED}`,
    ecommerce: {
      currency: CURRENCY.USD,
      value,
      items,
      paymentMethod,
    },
  });

  trackPublicEvent({
    event: `${eventPrefix}${CUSTOMER_IO_EVENT.COMPLETE_PURCHASE_CLICKED}`,
    properties: {
      source: window.location.href,
      value,
      items,
      paymentMethod,
    },
    userId: user?.email,
  });
};
